import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { handleRespError } from '@open-tender/utils'
import {
  selectBrand,
  selectCateringOnly,
  selectCustomer,
  selectOneTimePasscode,
  signInCustomer,
  useAppDispatch,
  useAppSelector,
} from '@open-tender/cloud'
import {
  Content,
  HeaderDefault,
  Main,
  PageTitle,
  PageContainer,
  PageContent,
  Loading,
  Message,
} from 'components'

const Punchh = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { title: siteTitle } = useAppSelector(selectBrand) || {}
  const { auth } = useAppSelector(selectCustomer)
  const cateringOnly = useAppSelector(selectCateringOnly)
  const { loading, error } = useAppSelector(selectOneTimePasscode)
  const isLoading = loading === 'pending'
  const err = error ? handleRespError(error) : null
  const errMsg = err ? err.detail : null
  const title = errMsg ? 'Something went wrong' : 'Retrieving your account'
  const subtitle = errMsg
    ? 'Please review the error below and retry your request or contact support'
    : 'Please hang tight. This will only take a second.'
  const query = new URLSearchParams(useLocation().search)
  const token = query.get('access_token')
  // Where to land after SSO. Catering-only brands (e.g. Clean Eatz) open the
  // catering ordering flow instead of the account page; other brands keep the
  // existing /account behavior. Punchh can override via a `redirect` param.
  const redirectTo =
    query.get('redirect') || (cateringOnly ? '/catering-address' : '/account')

  useEffect(() => {
    if (auth) {
      navigate(redirectTo)
    } else if (token) {
      dispatch(signInCustomer({ data: { token } }))
    } else {
      navigate(redirectTo)
    }
  }, [auth, token, redirectTo, navigate, dispatch])

  return (
    <>
      <Helmet>
        <title>Punchh | {siteTitle}</title>
      </Helmet>
      <Content>
        <HeaderDefault />
        <Main>
          <PageContainer style={{ maxWidth: '76.8rem' }}>
            <PageTitle title={title} subtitle={subtitle} />
            <PageContent>
              {isLoading ? (
                <Loading text="Contacting Punchh..." />
              ) : errMsg ? (
                <Message color="error" style={{ width: '100%' }}>
                  {errMsg}
                </Message>
              ) : null}
            </PageContent>
          </PageContainer>
        </Main>
      </Content>
    </>
  )
}

export default Punchh
